<template>
  <div>
    <div class="card-header">
      <form class="box-search" @submit.prevent="submitForm">
        <div class="form-group">
          <DateRangePicker
            placeholder="dd/mm/yyyy"
            class="w-100"
            :ranges="false"
            @update="transformDate()"
            v-model="dateRange"
            :locale-data="localeData"
          >
            <template v-slot:input="picker">
              <label
                v-if="picker.startDate"
                style="min-width: 13.5em"
                class="text-center font-size-12"
              >
              {{ picker.startDate | formatDate }} -
              {{ picker.endDate | formatDate }}
              </label>
              <label
                v-else
                style="min-width: 13.5em"
                class="font-size-12 time-placeholder"
              >
                Từ ngày - Đến ngày
              </label>
            </template>
          </DateRangePicker>
        </div>
        <div class="form-group">
            <Select2
              placeholder="Đối tác"
              v-model="search.partnerCode"
              :options="partnerCodeMap"
            >
            </Select2>
          </div>
        <div class="form-group">
          <Select2
            v-model="search.inviteCodes"
            :settings="setTingsInviteCode"
            placeholder="Mã cán bộ"
          ></Select2>
        </div>

        <div class="form-group form-group-action">
          <button
            @click="submitForm"
            class="pt-2 mr-2 btn btn-primary hc-37"
            data-toggle="tooltip"
            data-placement="top"
            title="Lọc"
          >
            <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
          </button>
          <button
            @click="resetFilters"
            type="button"
            class="pt-2 mr-2 btn btn-outline-light hc-37"
            data-toggle="tooltip"
            data-placement="top"
            title="Bỏ lọc"
          >
            <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
          </button>
        </div>
      </form>
    </div>
    <div class="card-body">
      <div class="tab-content" id="nav-tabContent">
        <div
          class="d-flex align-items-center gap-5 my-1 total-label"
        >
          <p >
            Tổng giao dịch: <span class="text-primary">{{ formatQuantity(countList?.totalTransaction ?? 0) || 0 }}</span>
          </p>
          <p>
            Tổng số tiền:
            <span class="text-primary"> {{ formatCurrency(countList?.totalAmount ?? 0) || 0 }}</span>
          </p>

          <p>
            Tổng thiết bị đang hoạt động:
          <span class="text-primary">  {{ formatQuantity(countList?.totalDeviceActive ?? 0) || 0 }}</span>
          </p>

        </div>

        <div class="p-0">
          <b-table
            :busy.sync="loading"
            sticky-header
            hover
            responsive
            :items="tableDataWithTotal"
            :fields="tableFields"
            :fixed="true"
            :bordered="true"
          >
            <template #table-busy>
              <div class="my-2 text-center">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
            <template #cell(employeeCode)="data">
              {{ data.item.employeeCode }}
            </template>

            <template #cell(totalTransaction)="data">
              {{ formatQuantity(data.item.totalTransaction) }}
            </template>

            <template #cell(totalAmount)="data">
              {{ formatCurrency(data.item.totalAmount) }}
            </template>

            <template #cell(totalDeviceActive)="data">
              {{ formatQuantity(data.item.totalDeviceActive) }}
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <div class="pagination-bottom">
      <b-pagination
        v-model="pagination.page"
        :total-rows="pagination.total"
        :per-page="pagination.limit"
        @change="onChangePage"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Config from '@/thirdParty/config'
import { ReportService } from '@/services/report.service'
import { CommonService } from '@/services/common.service'

const tableFields = [
  { key: 'index', label: 'STT', class: 'text-center', thStyle: { width: '80px' }, tdStyle: { width: '80px' } },
  { key: 'inviteCode', label: 'Mã cán bộ' },
  { key: 'totalTransaction', label: 'Số lượng giao dịch' },
  { key: 'totalAmount', label: 'Số tiền giao dịch' },
  { key: 'totalDeviceActive', label: 'Số thiết bị kích hoạt' }
]

export default {
  name: 'TransactionStatistics',
  data () {
    return {
      countList: {},
      loading: false,
      tableFields,
      tableData: [],
      search: {
        page: 1,
        limit: 20,
        employeeCode: '0'
      },
      dateRange: {
        startDate: null,
        endDate: null
      },
      localeData: Config.localeData,
      pagination: {
        total: 0,
        limit: 20,
        page: 1
      },
      partnerCodeMap: [],
      setTingsInviteCode: {
        placeholder: 'Tìm mã cán bộ',
        multiple: true,
        ajax: {
          delay: 500,
          transport: (params, success, failure) => {
            const txtSearch = params.data?.q?.trim() || ''
            if (!txtSearch) {
              return success({
                results: []
              })
            }
            const keySearch = txtSearch ?? ''
            if (this.tLoadOwner) {
              clearTimeout(this.tLoadOwner)
            }
            this.tLoadOwner = setTimeout(() => {
              CommonService.getListInviteCode({
                keyword: keySearch,
                sortResultList: [
                  {
                    field: 'createdDate',
                    direction: 'DESC'
                  }
                ]
              }) // AI
                .then((res) => {
                  success({
                    results:
                      res.data?.map((item) => {
                        return {
                          id: item?.inviteCode || '',
                          text: item.inviteCode || ''
                        }
                      }) || []
                  })
                })
                .catch(failure)
            }, 500)
          }
        }
      }
    }
  },

  computed: {
    tableDataWithTotal () {
      return [...this.tableData]
    }
  },

  async created () {
    this.fetchData()
    this.fetchĐataPartner()
  },

  methods: {
    async fetchĐataPartner () {
      try {
        const data = await CommonService.getListAgentPartner({ page: 1, limit: 1000 })
        if (data.code === 1000) {
          this.partnerCodeMap = data.data.map((item) => {
            return {
              id: item?.code,
              text: item.name || ''
            }
          }) || []
          this.partnerCodeMap.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) {
        this.showFailMx(error.message ?? error)
      }
    },
    onChangePage (page) {
      this.pagination.page = page
      this.fetchData()
    },
    resetFilters () {
      this.search = {}
      this.dateRange = {
        startDate: null,
        endDate: null
      }
      this.pagination.page = 1
      this.fetchData()
    },
    filterObject (obj) {
      const result = {}

      let hasInvalidValue = false

      for (const [key, value] of Object.entries(obj)) {
        if (value === null || value === '0') {
          hasInvalidValue = true
          continue
        }
        result[key] = value
      }

      return hasInvalidValue ? result : obj
    },
    async fetchData () {
      try {
        this.loading = true
        const payload = this.filterObject(this.search)
        const res = await ReportService.getListReportByStaff({
          ...payload,
          page: this.pagination.page,
          limit: this.pagination.limit,
          isCountTotal: true
          // sortResultList: [
          //   {
          //     field: 'createdDate',
          //     direction: 'DESC'
          //   }
          // ]
        })
        this.$emit('params', {
          ...payload,
          page: this.pagination.page,
          limit: this.pagination.limit,
          isCountTotal: true
          // sortResultList: [
          //   {
          //     field: 'activatedTime',
          //     direction: 'DESC'
          //   }
          // ]
        })
        if (res.code === 1000) {
          this.tableData =
            res.data?.filter((item) => item.inviteCode !== 'TOTAL') || []
          this.countList =
            res.data?.find((item) => item.inviteCode === 'TOTAL') || {}
          this.pagination.total = res.totalPage.total ?? 0
        } else {
          this.showErr(res.message)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.showErr(error.message)
      } finally {
        this.loading = false
      }
    },
    showErr (message) {
      this.notiModal = true
      this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
      this.msgNoti = message
    },
    transformDate () {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.search.fromDate = moment(this.dateRange.startDate)
          .startOf('day')
          .valueOf()
        this.search.toDate = moment(this.dateRange.endDate)
          .endOf('day')
          .valueOf()
      } else {
        delete this.search.toDate
        delete this.search.dateTo
      }
    },

    async submitForm (event) {
      event.preventDefault()
      this.pagination.page = 1
      await this.fetchData()
    },

    formatQuantity (value) {
      return value?.toLocaleString('vi-VN')
    },
    formatCurrency (value) {
      return value?.toLocaleString('vi-VN') + ' VND'
    }
  }
}
</script>

<style scoped>
:deep(.box-search) {
  padding: 0 !important;
}

:deep(.card-body) {
  padding: 10px 0 !important;
}

:deep(.table tr.table-success) {
  background-color: #28a745 !important;
}

:deep(.table-success td) {
  color: white !important;
  font-weight: bold;
}
</style>
